import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../../context";
import { Form } from "antd";
import { LoginRegisterWrapper } from "./LoginRegister.style";
import { BiError } from "react-icons/bi";
import LoginForm from "./LoginForm";
import UserInfoForm from "./UserInfoForm";
import openkit from "openkit";
import { useFacebook, loginFB } from "./facebook";
// import FacebookLogin from "react-facebook-login";
import { FaFacebook, FaGoogle, FaInfoCircle } from "react-icons/fa";
import { GoogleLogin, GoogleLogout } from "react-google-login";
import {
  loginWithFacebookToken,
  loginWithGoogleToken,
} from "../../library/user";
import RecoverForm from "./RecoverForm";
import NewPasswordForm from "./NewPasswordForm";

function LoginRegisterDialog({ setIsModalVisible, initialState }) {
  const [action, setAction] = useState("login");
  const [form] = Form.useForm();
  const info = useContext(AppContext);
  const [notification, setNotification] = useState(null);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [isPostRegisterDialogVisible, setIsPostRegisterDialogVisible] =
    useState(false);
  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  const [termsAndConditionsAccepted, setTermsAndConditionsAccepted] =
    useState(false);

  const [FB, isReady] = useFacebook();
  // const [facebook, isFacebookReady] = useFacebook();

  useEffect(() => {
    if (initialState) setAction(initialState);
  }, []);

  useEffect(() => {
    switch (action) {
      case "login":
        setNotification(info.t("insertUserData"));
        break;
      case "recover":
        setNotification(info.t("insertEmailToRecover"));
        break;
      case "recoverEmailSubmitted":
        setNotification(info.t("recoverEmailSubmitted"));
        break;
      case "newPassword":
        setNotification(info.t("newPassword"));
        break;
      case "newPasswordSubmitted":
        setNotification(info.t("newPasswordSubmitted"));
        break;
      case "loginError":
        setNotification(
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <BiError color="ff8c00" />{" "}
            <div style={{ color: "#ff8c00" }}>{info.t("userError")}</div>
          </div>
        );
        break;
      case "loggedIn":
        setNotification(info.t("loginSucceeded"));
        break;
      case "register":
        setNotification(info.t("insertRegistrationData"));
        break;
      case "userExists":
        setNotification(
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
            }}
          >
            <BiError color="ff8c00" />{" "}
            <div style={{ color: "#ff8c00" }}>{info.t("userExists")}</div>
          </div>
        );
        break;
      case "newUserSuccess":
        setNotification(info.t("newUserSucces"));
        break;
      case "confirmRegistration":
        setNotification(info.t("confirmRegistration"));
        break;
      default:
        break;
    }
  }, [action]);

  const login = async () => {
    const user = form.getFieldsValue();
    const result = await openkit.auth.loginWithEmailAndPassword(
      user.email,
      user.password
    );
    if (!result) {
      setAction("loginError");
      return;
    }
    const userData = await openkit.auth.getLoggedInUser();
    info.setUser(userData);
    setAction("loggedIn");
  };

  const submitRecoverEmail = async () => {
    const user = form.getFieldsValue();
    const result = await openkit.data.create("forgot_passwords", user);
    //   user.email,
    //   user.password
    // );
    // if (!result) {
    //   setAction("loginError");
    //   return;
    // }
    setAction("recoverEmailSubmitted");
  };

  const submitNewPassword = async () => {
    const user = form.getFieldsValue();
    const result = await openkit.auth.resetPassword(
      info.resetPasswordId,
      user.email,
      user.password
    );
    login();
    // setAction("newPasswordSubmitted");
  };

  const register = async () => {
    const user = form.getFieldsValue();

    try {
      const res = await openkit.users.createUser(user);
      if (res) {
        setAction("confirmRegistration");
      } else {
        setAction("userExists");
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleGoogleLogin = async (googleData) => {
    const tokenId = googleData.tokenId;
    const user = await loginWithGoogleToken(tokenId);
    if (user) {
      info.setUser(user);
      setNotification(info.t("loginSucceeded"));
      setAction("loggedIn");
    }
  };

  const handleFacebookLogin = () => {
    const afterLogin = (user) => {
      if (user) {
        info.setUser(user);
        setNotification(info.t("loginSucceeded"));
        setAction("loggedIn");
      }
    };
    const user = loginFB(FB, afterLogin);
  };

  return (
    <>
      <LoginRegisterWrapper>
        <div className="ahp-header" style={{ marginTop: -20 }}>
          <img
            src="https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/11/logo.png"
            alt="aldeias historicas logo"
          />
        </div>
        <div
          className="ahp-img-background"
          style={{
            backgroundImage:
              "url('https://aldeiashistoricasdeportugal.com/wp-content/uploads/2018/12/AH-Idanha-a-Velha-1.jpg'",
          }}
        ></div>
        {/* LOGIN */}
        <div className="ahp-notification">{notification}</div>
        {(action === "login" || action === "loginError") && (
          <>
            <LoginForm
              form={form && form}
              onFinish={login}
              info={info}
              setAction={setAction}
              setIsModalVisible={setIsModalVisible}
            />
            <div style={{ display: "flex" }}>
              <div className="new-user" onClick={() => setAction("recover")}>
                {info.t("recover")}
              </div>
              <div className="new-user" onClick={() => setAction("register")}>
                {info.t("register")}
              </div>
            </div>
          </>
        )}
        {action === "recover" && (
          <>
            <RecoverForm
              form={form && form}
              onFinish={submitRecoverEmail}
              info={info}
              setAction={setAction}
              setIsModalVisible={setIsModalVisible}
            />
            <div className="new-user" onClick={() => setAction("login")}>
              {info.t("login")}
            </div>
          </>
        )}
        {/* REGISTER */}
        {action === "register" && (
          <>
            <UserInfoForm
              form={form}
              onFinish={register}
              showPrivacyAndTerms
              actionButtonText={info.t("register")}
              setIsModalVisible={setIsModalVisible}
            />

            <div className="new-user" onClick={() => setAction("login")}>
              {info.t("login")}
            </div>
          </>
        )}
        {/* NEW PASSWORD */}
        {action === "newPassword" && (
          <>
            <NewPasswordForm
              form={form}
              onFinish={submitNewPassword}
              showPrivacyAndTerms
              actionButtonText={info.t("submit")}
              setIsModalVisible={setIsModalVisible}
            />

            <div className="new-user" onClick={() => setAction("login")}>
              {info.t("login")}
            </div>
          </>
        )}
        {action === "userExists" && (
          <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
            <div className="new-user" onClick={() => setAction("login")}>
              {info.t("login")}
            </div>
            <div className="new-user" onClick={() => setAction("register")}>
              {info.t("register")}
            </div>
          </div>
        )}

        {/* {action !== "loggedIn" && (
        <div className="ahp-federated-login-btns">
          <GoogleLogin
            className="google-btn"
            clientId="1036086323592-vsjmq1kf70j9oautdj9fmb9477oujkjp.apps.googleusercontent.com"
            buttonText="Login"
            onSuccess={handleGoogleLogin}
            onFailure={handleGoogleLogin}
            cookiePolicy={"single_host_origin"}
            // offline
            // responseType="code"
            render={(renderProps) => (
              <button
                className="ahp-google-btn"
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
              >
                <FaGoogle style={{ color: "#4285F4" }} />
                {info.t("loginWithGoogle")}
              </button>
            )}
          ></GoogleLogin>

          <button className="ahp-facebook-btn" onClick={handleFacebookLogin}>
            <FaFacebook style={{ color: "#4267B2" }} />
            {info.t("loginWithFacebook")}
          </button>
        </div>
      )} */}
        {/* <button
        onClick={() => {
          FB.logout(function (response) {
            // Person is now logged out
            console.log("response :>> ", response);
          });
        }}
      >
        LOGOUT FB
      </button> */}
        {/* LOGGEDIN */}
        {(action === "loggedIn" ||
          action === "confirmRegistration" ||
          action === "recoverEmailSubmitted" ||
          action === "newPasswordSubmitted") && (
          <div className="result-container">
            <button className="ok-btn" onClick={handleOk}>
              OK
            </button>
          </div>
        )}
      </LoginRegisterWrapper>
    </>
  );
}

export default LoginRegisterDialog;
